<template>
	<div class="review-mode-bar" v-if="reviewModeData">
		{{ $t('review-mode.message') }}."{{ reviewModeData }}"
		<nk-button class="btn btn-warning mx-auto" :options="returnToMainDBButtonOptions" @click="returnToMainDB"></nk-button>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	export default {
		data() {
			return {
				returnToMainDBButtonOptions: {
					title: this.$t('review-mode.return-to-main-db'),
					isPrimary: true,
				},
			}
		},
		computed: {
			...mapGetters({
				reviewModeData: 'useraccount/reviewModeData',
			}),
		},
		methods: {
			...mapActions('useraccount', ['makeReviewModeDataEmpty', 'clearUser']),
			returnToMainDB() {
				this.makeReviewModeDataEmpty()
				this.clearUser()
				document.location = '/'
			}
		}
	}
</script>

<style lang="less">
	.review-mode-bar {
		text-align: center;
		background-color: red;
		color: #fff;
		padding: 10px;
	}
</style>